import React, { ChangeEvent, ClipboardEvent, useEffect } from "react";
import { endpointInstance } from "../methods/Methods";
import _ from "lodash";
import moment from "moment";
import encrypt from "../methods/Encrypt";
import { Button, Card, Checkbox, Col, Divider, Input, Row, Tooltip, Typography } from "antd";
import HeaderComponent from "../components/HeaderComponent";
import { StyleSheet } from "../StyleSheet";
import InfoCardComponent from "../components/InfoCardComponent";
import PaymentAmount from "../components/PaymentAmount";
import { InfoCircleOutlined } from '@ant-design/icons';
import { Link, useNavigate } from "react-router-dom";
import stylesCss from "../components/css/images.module.css";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import PaymentForms from "../components/PaymentForms";
import AlertModal, { PaymentData } from "../components/AlertModal";
import Loading from "../components/Loading";
import { LeftOutlined } from '@ant-design/icons';


const { Text } = Typography;

const PayWithCard = () => {
    const navigate = useNavigate();
    const [cardNumber, setCardNumber] = React.useState<string>("");
    const [cardName, setCardName] = React.useState<string>("");
    const [expirationCard, setExpirationCard] = React.useState<string>("");
    const [cardCvv, setCardCvv] = React.useState<string>("");
    const [balance, setBalance] = React.useState<string>("");
    const [balancePesos, setBalancePesos] = React.useState<string>("");
    const [balanceCents, setBalanceCents] = React.useState(0);
    const [idCliente, setIdCliente] = React.useState<string>("");
    const [limitDate, setLimitDate] = React.useState<string>("");
    const [btnDisable, setBtnDisable] = React.useState<boolean>(true);
    const [termsAndCond, setTermsAndCond] = React.useState<boolean>(false);
    const [isReceiptPayment, setIsReceiptPayment] = React.useState<boolean>(false);
    const [loading, setLoading] = React.useState<boolean>(false);
    const [showModal, setShowModal] = React.useState(false);
    const [textModal, setTextModal] = React.useState("");
    const [name, setName] = React.useState<string>("");
    const [concept, setConcept] = React.useState<string>("");
    const [hasError, setHasError] = React.useState<boolean>(false);
    const [paymentData, setPaymentData] = React.useState<PaymentData>();
    const call = endpointInstance;

    useEffect(() => {
        const balanceTmp = localStorage.getItem("balance");
        if (balanceTmp && !_.isEmpty(balanceTmp)) {
            setBalance(balanceTmp);
            let [peso, centavo] = balanceTmp.split('.');
            setBalancePesos(peso);
            setBalanceCents(parseInt(centavo, 10));
        } else {
            setHasError(true);
        }

        const idClienteTmp = localStorage.getItem("idCliente");
        if (idClienteTmp && !_.isEmpty(idClienteTmp)) {
            setIdCliente(idClienteTmp);
        } else {
            setHasError(true);
        }

        const limitTmp = localStorage.getItem("limit");
        if (limitTmp && !_.isEmpty(limitTmp)) {
            setLimitDate(limitTmp);
        } else {
            setHasError(true);
        }

        const nameTmp = localStorage.getItem("name");
        if (nameTmp && !_.isEmpty(nameTmp)) {
            setName(nameTmp);
        } else {
            setHasError(true);
        }

        const conceptTmp = localStorage.getItem("concept");
        if (conceptTmp && !_.isEmpty(conceptTmp)) {
            setConcept(conceptTmp);
        } else {
            setHasError(true);
        }
    }, []);

    useEffect(() => {
        if (
            !_.isEmpty(cardName) &&
            !_.isEmpty(cardNumber) &&
            cardNumber.length === 16 &&
            !_.isEmpty(expirationCard) &&
            expirationCard.length === 4 &&
            !_.isEmpty(cardCvv) &&
            cardCvv.length === 3 &&
            !_.isEmpty(balance) &&
            termsAndCond
        ) {
            setBtnDisable(false);
        } else {
            setBtnDisable(true);
        }
    }, [cardNumber, cardName, expirationCard, cardCvv, balance, termsAndCond]);

    const pad = (textoArellenar: string, length: number): string => {
        let padding = 0;
        var str = textoArellenar + "";
        return length <= str.length ? str : pad(padding + str, length);
    };

    const doPayment = async () => {
        const datePayFormat = limitDate.split("-");
        const dateLimitPay =
            datePayFormat[0].padStart(2, "0") +
            moment().month(datePayFormat[1]).format("MM") +
            datePayFormat[2];
        const amountToPayment = pad(balance.replace(/[.,]/g, ""), 7);
        const body = {
            sucursal: idCliente.substring(0, 3),
            suscriptor: idCliente.substring(3, 10),
            reference: "12" + idCliente + dateLimitPay + amountToPayment,
            name: encrypt(cardName.toUpperCase()),
            number: encrypt(cardNumber),
            expmonth: encrypt(expirationCard.substring(0, 2)),
            expyear: encrypt(expirationCard.substring(2, 4)),
            cvv: encrypt(cardCvv),
            amount: balance.replace(/[,]/g, ""),
        };

        setLoading(true);
        await call
            .addPayment(body)
            .then((response) => {
                if (response.data.data[0].respuesta === "ERROR") {
                    setTextModal(response.data.data[0].mensaje);
                    setShowModal(true);
                } else if (
                    response.data.data[0].data.status === "1" &&
                    parseInt(response.data.data[0].data.folio) > 0
                ) {
                    setIsReceiptPayment(true);
                    const fecha = response.data.data[0].data.fechaCompra;
                    const [dateFormatted, hourFormatted] = fecha.split(" - ");
                    setPaymentData({
                        date: dateFormatted,
                        time: hourFormatted,
                        amount: balance,
                        name: name,
                        client: idCliente,
                        idTransaction: "",
                        concept: concept,
                        card: "************" + cardNumber.substring(12, 16)
                    });
                    setShowModal(true);
                } else {
                    setTextModal(
                        response.data.data[0].data.message
                            ? response.data.data[0].data.message
                            : response.data.data[0].mensaje
                    );
                    setShowModal(true);
                }
                setLoading(false);
            })
            .catch(() => {
                setTextModal("No fue posible realizar el pago, intenta más tarde.");
                setShowModal(true);
                setLoading(false);
            });
    };

    const handleExpirationCard = (value: string) => {
        setExpirationCard(value.replace(/[^0-9]/g, ''));
    };

    const onChangeCheck = (e: CheckboxChangeEvent) => {
        setTermsAndCond(e.target.checked);
    };

    const handleCopy = (e: ClipboardEvent<HTMLInputElement>) => {
        // Prevent copying when someone tries to copy from the input
        e.preventDefault();
    };

    const handlePaste = (e: ClipboardEvent<HTMLInputElement>) => {
        // Prevent pasting when someone tries to paste into the input
        e.preventDefault();
    };

    return (
        <>
            {
                loading ?
                    <Loading />
                    :
                    hasError ?
                        <>
                            <HeaderComponent />
                            <div style={styles.pageContainer}>
                                <Row style={styles.formContainer} justify={'center'}>
                                    <Col span={16}>
                                        <InfoCardComponent
                                            color="#FFC439" colorText="#000"
                                            description={"Por el momento no es posible mostrar información de su contrato, intente más tarde."} />
                                    </Col>
                                    <Col span={16} style={styles.rowErrorButton}>
                                        <Button
                                            size='large'
                                            type="primary"
                                            style={styles.buttonReturn}
                                            onClick={() => navigate("/")}
                                        >
                                            <LeftOutlined />
                                            Regresar
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                            <PaymentForms />
                        </>
                        :
                        <>
                            <HeaderComponent />
                            <div style={{ padding: 15 }}>
                                <div style={styles.divTitle}>
                                    <Text style={styles.textTitle} className="page-title">
                                        Pago con tarjeta de débito/crédito
                                    </Text>
                                    <Divider style={styles.divider} />
                                </div>
                                <Row justify={"center"} style={{ marginTop: 5 }}>
                                    <Col xs={24} md={10}>
                                        <InfoCardComponent
                                            title="¡Estimado usuario!"
                                            description={"Por el momento no aceptamos pagos con American Express."}
                                        />
                                    </Col>
                                </Row>
                                <Row justify={"center"} style={{ marginTop: 15 }}>
                                    <Col xs={24} md={10}>
                                        <PaymentAmount
                                            paymentsPesos={balancePesos}
                                            paymentsCentavo={balanceCents}
                                        />
                                    </Col>
                                </Row>
                                <Row justify={"center"} style={{ marginTop: 15 }}>
                                    <Col xs={24} md={10}>
                                        <Card style={styles.cardView}>
                                            <Row gutter={[12, 12]} style={{ marginTop: 10 }}>
                                                <Col xs={24}>
                                                    <Text style={styles.inputTitle}>
                                                        Nombre del tarjetahabiente
                                                    </Text>
                                                    <Input
                                                        value={cardName}
                                                        style={styles.inputText}
                                                        placeholder='Nombre del tarjetahabiente'
                                                        onChange={(e: ChangeEvent<HTMLInputElement>) =>
                                                            setCardName(
                                                                e.target.value.replace(/[^A-Za-záéíóúÁÉÍÓÚñÑüÜ\s]/g, "")
                                                            )
                                                        }
                                                        suffix={
                                                            <Tooltip title={`Nombre del titular de la tarjeta.`} >
                                                                <InfoCircleOutlined style={{ color: 'rgba(117, 121, 130, 255)' }} />
                                                            </Tooltip>
                                                        }
                                                        onCopy={handleCopy}
                                                        onCut={handleCopy}
                                                        onPaste={handlePaste}
                                                    />
                                                </Col>
                                                <Col xs={24} md={8}>
                                                    <Text style={styles.inputTitle}>
                                                        Número de Tarjeta
                                                    </Text>
                                                    <Input
                                                        value={cardNumber}
                                                        style={styles.inputText}
                                                        placeholder='0000 0000 0000 0000'
                                                        onChange={(e: ChangeEvent<HTMLInputElement>) =>
                                                            setCardNumber(e.target.value.replace(/[^0-9]/g, ""))
                                                        }
                                                        maxLength={16}
                                                        onCopy={handleCopy}
                                                        onCut={handleCopy}
                                                        onPaste={handlePaste}
                                                    />
                                                </Col>
                                                <Col xs={12} md={8}>
                                                    <Text style={styles.inputTitle}>
                                                        Vencimiento
                                                    </Text>
                                                    <Input
                                                        value={expirationCard.replace(/(\d{2})(\d{2})/, "$1/$2")}
                                                        style={styles.inputText}
                                                        placeholder='mm/aa'
                                                        onChange={(event: any) => handleExpirationCard(event.target.value)}
                                                        maxLength={5}
                                                        suffix={
                                                            <Tooltip title={`Fecha de vencimiento: Fecha ubicada al frente de tu tarjeta, debajo del número de tarjeta.`} >
                                                                <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                                                            </Tooltip>
                                                        }
                                                        onCopy={handleCopy}
                                                        onCut={handleCopy}
                                                        onPaste={handlePaste}
                                                    />
                                                </Col>
                                                <Col xs={12} md={8}>
                                                    <Text style={styles.inputTitle}>
                                                        CVV
                                                    </Text>
                                                    <Input
                                                        value={cardCvv}
                                                        style={styles.inputText}
                                                        placeholder='000'
                                                        onChange={(element: any) => setCardCvv(element.target.value.replace(/[^0-9]/g, ''))}
                                                        maxLength={3}
                                                        suffix={
                                                            <Tooltip title={`CVV: Código de 3 dígitos, situado al reverso de tu tarjeta.`} >
                                                                <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                                                            </Tooltip>
                                                        }
                                                        onCopy={handleCopy}
                                                        onCut={handleCopy}
                                                        onPaste={handlePaste}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row gutter={[12, 12]} style={{ marginTop: 25 }}>
                                                <Col xs={24}>
                                                    <Checkbox
                                                        checked={termsAndCond}
                                                        onChange={onChangeCheck}
                                                    >
                                                        <Text style={{ ...styles.inputTitle, fontSize: 11 }}>
                                                            Estoy de acuerdo con los&nbsp;
                                                        </Text>
                                                        <Link
                                                            style={{
                                                                color: "#1786ff",
                                                                fontWeight: 500,
                                                                fontSize: 13,
                                                                display: 'flex',
                                                                alignItems: 'center'
                                                            }}
                                                            target='_blank'
                                                            to={"https://megacable.com.mx/privacidad"}>
                                                            Términos y Condiciones de Uso
                                                        </Link>
                                                    </Checkbox>
                                                </Col>
                                            </Row>
                                            <Row
                                                className={stylesCss.rowButtons}
                                                justify={'center'}
                                                gutter={[16, 16]}
                                                style={styles.buttonRow}
                                            >
                                                <Col xs={24} sm={12} style={styles.buttonCol}>
                                                    <Button
                                                        block
                                                        disabled={btnDisable}
                                                        size='large'
                                                        style={{ ...styles.buttonPrimary, backgroundColor: btnDisable ? '#909292' : '#0055c2' }}
                                                        onClick={() => doPayment()}
                                                    >
                                                        Pagar
                                                    </Button>
                                                </Col>
                                                <Col xs={24} sm={12} style={styles.buttonCol}>
                                                    <Button
                                                        block
                                                        size='large'
                                                        type="primary"
                                                        ghost
                                                        style={styles.buttonReturn}
                                                        onMouseEnter={(e: any) => {
                                                            e.currentTarget.style.backgroundColor = "#0079FF";
                                                            e.currentTarget.style.color = "#ffffff";
                                                            e.currentTarget.style.borderColor = "#0079FF";
                                                        }}
                                                        onMouseLeave={(e: any) => {
                                                            e.currentTarget.style.backgroundColor = "transparent";
                                                            e.currentTarget.style.color = "#0079FF";
                                                            e.currentTarget.style.borderColor = "#0079FF";
                                                        }}
                                                        onClick={() => navigate("/")}
                                                    >
                                                        Cancelar
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col>
                                </Row>
                            </div>
                            <PaymentForms />
                            <AlertModal
                                title={"Pago con tarjeta"}
                                message={textModal}
                                show={showModal}
                                isReceiptPayment={isReceiptPayment}
                                paymentData={paymentData}
                            />
                        </>
            }
        </>
    );
};

const styles = StyleSheet.create({
    divider: {
        borderBlockStart: "1px solid #c8c8c8",
        margin: "20px 0px 20px",
        color: "#c8c8c8",
        width: "10%",
        minWidth: "10%"
    },
    divTitle: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        flexDirection: 'column'
    },
    textTitle: {
        color: 'black',
        fontWeight: 700,
        textAlign: 'center',
        lineHeight: 1.2
    },
    cardView: {
        backgroundColor: 'white',
        borderRadius: 15,
        boxShadow: "3px 3px 5px 0px rgba(0,0,0,0.10)",
        padding: 10
    },
    inputText: {
        marginTop: 10,
        color: "#000000",
        borderColor: '#000000',
        fontSize: 13
    },
    inputTitle: {
        color: "black",
        fontWeight: 500,
        fontSize: 13
    },
    buttonPrimary: {
        padding: "0px 25px 0px 25px",
        borderRadius: 20,
        color: 'white',
        fontSize: 13,
        width: 300,
        textTransform: "uppercase",
    },
    divButton: {
        marginTop: 25,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%'
    },
    pageContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '90vh',
    },
    formContainer: {
        marginTop: "2rem",
    },
    rowErrorButton: {
        marginTop: 25,
        display: 'flex',
        justifyContent: 'center'
    },
    buttonRow: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 30,
    },
    buttonReturn: {
        backgroundColor: 'transparent',
        borderRadius: 20,
        color: '#0079FF',
        borderColor: '#0079FF',
        fontSize: 13,
        width: "100%",
        textTransform: "uppercase",
        boxShadow: "3px 3px 5px 0px rgba(0,0,0,0.10)",
    },
    buttonCol: {
        display: 'flex',
        justifyContent: 'center'
    },

});

export default PayWithCard;